import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { EInterceptorOptionsHTTPHeaders } from "src/app/_helpers/interceptors/EInterceptorOptionsHTTPHeaders";
import { Utilities } from "src/app/_helpers/utility/utilities";
import {
  IOrganizationAssessment,
  IUnSavedOrganizationAssessment,
} from "src/app/_interfaces/IOrganizationAssessment";
import { IUnsavedRelativeRiskAssessment } from "src/app/_interfaces/IRelativeRiskAssessment";
import { WfdssCase } from "src/app/_models/incident/wfdssCase/wfdssCase";
// import { environment } from "../../../environments/environment";
import { ConfigService } from "../config.service";

@Injectable({
  providedIn: "root",
})
export class OrganizationAssessmentDataService {
  private readonly baseUrl = this.environment.caseApi.baseUrl;
  constructor(private httpSvc: HttpClient, private environment: ConfigService) {}

  /**
   * @description: Creates or updates the organization assessment for the corresponding wfdss case
   */
  putOrganizationAssessmentForWfdssCaseId(
    wfdssCaseId: WfdssCase["wfdssCaseId"],
    organizationAssessment: IUnSavedOrganizationAssessment
  ) {
    const dataToSave = this.addRequiredKeys(
      organizationAssessment,
      wfdssCaseId
    );
    return this.httpSvc.put(
      `${this.baseUrl}/cases/${wfdssCaseId}/latestOrganizationAssessment`,
      dataToSave
    );
  }

  getLatestOrganizationAssessmentForWfdssCaseId(wfdssCaseId: WfdssCase["wfdssCaseId"]) {
    return this.httpSvc.get<IOrganizationAssessment>(
      `${this.baseUrl}/cases/${wfdssCaseId}/latestOrganizationAssessment`,
      {
        headers: Utilities.appendHTTPHeaderForInterceptor([
          EInterceptorOptionsHTTPHeaders.SuppressErrorInterceptor,
        ]),
      }
    );
  }

  addRequiredKeys(
    unsavedOrganizationAssessment: IUnSavedOrganizationAssessment,
    wfdssCaseId
  ) {
    //@ts-ignore
    const assessmentToSave: Partial<IOrganizationAssessment> = {
      ...unsavedOrganizationAssessment,
    };

    assessmentToSave.organizationAssessmentId = null;
    assessmentToSave.wfdssCaseId ??= wfdssCaseId;
    assessmentToSave.userIdThatCompletedThisAssessment ??= null;
    assessmentToSave.isReadyForPublication ??= false;
    assessmentToSave.dateTimeWhenMarkedReadyForPublication ??= null;

    return assessmentToSave;
  }
}
